<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn"></div>-->
    <div id="contentDiv">
      <div class="head_title">
        <div class="head_title_font">今日餐饮&gt;</div>
      </div>

      <div class="body_content">
        <div class="body_top row">
          <div  class="col-xs-3 col-sm-3">
            <router-link to="/cateringQrcode">
            <div class="btn btn_option btn_square">
              <img class="qrcode" src="../assets/img/right/clazz/none.png"/>
              <span>办理就餐</span>
            </div>
            </router-link>
            <div class="btn btn_option btn_square" @click="toToday()">
              <img class="refresh" src="../assets/img/right/clazz/none.png"/>
              <span>刷新</span>
            </div>
          </div>
          <div  class="col-xs-9 col-sm-9">
          <div class="squareview">
            <span class="squaretext">今日开班</span>
            <span class="squarenumber">{{dataStatistics.classnum||0}}</span>
          </div>

          <div class="squareview">
            <span class="squaretext">注册人数</span>
            <span class="squarenumber">{{dataStatistics.studentnum||0}}</span>
            <a href="javascript:" @click="classCount(0)">详情</a>
          </div>


          <div class="squareview historyview">
            <span class="squaretext">历史查询</span>
            <div>
              <input type="text" data-vv-scope="clazz" data-vv-as="日期" name="etime" class="form-control" id="menuDate" placeholder="请选择日期" readonly v-model="etime"/>
              <button type="button" class="btn btn-default btn_option" @click="toToday()">回到今天</button>
            </div>
          </div>
          </div>
        </div>
        <div  class="col-xs-4 col-sm-4 meal breakfirst">
          <div class="title">早餐</div>
          <div class="squareview">
            <span class="squaretext">就餐人数</span>
            <span class="squarenumber">{{dataStatistics.recordnum1||0}}</span>
            <a href="javascript:" @click="classCount(2, 1)">详情</a>
          </div>

        </div>
        <div  class="col-xs-4 col-sm-4 meal lunch">
          <div class="title">午餐</div>
          <div class="squareview">
            <span class="squaretext">登记人数</span>
            <span class="squarenumber">{{dataStatistics.registernum2||0}}</span>
            <a href="javascript:" @click="classCount(1, 2)">详情</a>
          </div>
          <div class="squareview">
            <span class="squaretext">就餐人数</span>
            <span class="squarenumber">{{dataStatistics.recordnum2||0}}</span>
            <a href="javascript:" @click="classCount(2, 2)">详情</a>
          </div>

        </div>
        <div  class="col-xs-4 col-sm-4 meal dinner">
          <div class="title">晚餐</div>
          <div class="squareview">
            <span class="squaretext">登记人数</span>
            <span class="squarenumber">{{dataStatistics.registernum4||0}}</span>
            <a href="javascript:" @click="classCount(1, 4)">详情</a>
          </div>
          <div class="squareview">
            <span class="squaretext">就餐人数</span>
            <span class="squarenumber">{{dataStatistics.recordnum4||0}}</span>
            <a href="javascript:" @click="classCount(2, 4)">详情</a>
          </div>

        </div>
      </div>
    </div>

    <div class="modal fade" id="classCountModal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop='static'>
      <div class="modal-dialog modal-dialog-look">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
              &times;
            </button>
            <h4 class="modal-title" id="myModalLabel_showImage">
              {{catering_type[type]}}{{statistics_type[stype]}}人数
            </h4>
          </div>
          <div class="modal-body modal-body-look">
            <table class="table table-striped table-bordered table_trainingManage">
              <thead>
              <tr>
                <th>班级</th>
                <th width="25%">数量</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(d, index) in classList" :key="index">
                <td>{{d.name}}</td>
                <td>{{d.studentnum}}&nbsp;&nbsp;<a v-if="stype==2" href="javascript:" @click="classStudent(2, type, d.id)">人员</a> </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="classStudentModal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop='static'>
      <div class="modal-dialog modal-dialog-look">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
              &times;
            </button>
            <h4 class="modal-title">
              {{catering_type[type]}}{{statistics_type[stype]}}人员
            </h4>
          </div>
          <div class="modal-body modal-body-look">
            <table class="table table-striped table-bordered table_trainingManage">
              <thead>
              <tr>
                <th width="10%">序号</th>
                <th>姓名</th>
                <th width="40%">时间</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(d, index) in studentList" :key="index">
                <td>{{index + 1}}</td>
                <td>{{d.userName}}</td>
                <td>{{d.etime}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {schoolAxios} from '../main';
  import {getContentSize} from './mainView';
  import pageView from './pageView';
  import dictionaryData from '../json/dictionary';

  export default {
    name: "trainingManage",
    components:{pageView},
    data() {
      return {
        clazzId: this.$store.state.clazzId,
        publishStatus: this.$store.state.publishStatus,
        classStatus: this.$store.state.classStatus,
        userId:this.$store.state.userId,
        resourcePath:  this.$store.state.serviceBase + "resources/",
        //教务领导
        leaderUserCode: this.$store.state.leaderUserCode,
        userCode: this.$store.state.userCode,

        dataStatistics:{},
        classList:[],
        studentList:[],
        etime:"",
        option_flag: 'add',
        catering_type: dictionaryData.catering_type,
        type:0,//对应catering_type
        statistics_type:{//统计类型
          0:'注册',
          1:'登记',
          2:'就餐'
        },
        stype: 0,//对应 statistics_type
        searchParams: {
          name:'',
          type:"",
          all: 0,
          rows: 10,
          page:1
        },
      }
    },
    filters: {
      formatType(value){
        let this_ = this;
        if(dictionaryData.menu_type && value){
          value = dictionaryData.menu_type[value];
        }
        return value;
      }
    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();

        this_.initData();

        this_.dateDefault();
        this_.closeModal();
      });
    },
    methods: {
            /**
       * 加载培训人员列表
       */
      initData(){
        let this_ = this;
        let params = {};
        if(this_.etime) params.etime = this_.etime + " 00:00:00";

        schoolAxios({
          method: 'get',
          url: 'cateringRecord/statistics',
          params: params
        }).then(function (resp) {
          if(resp.data.success){
            // console.info(this_.userId);
            this_.dataStatistics = resp.data.data;
          }else{
            (resp.data.message||"数据加载失败").showMessage();
          }
        });
      },
      toToday(){
        this.etime="";
        this.initData();
      },
      classCount(stype, type){
        let this_ = this;
        this_.stype = stype;
        this_.type = type;
        let url = "";
        switch (stype) {
          case 0:
            url = "cateringRecord/classCount";
            break;
          case 1:
            url="cateringRegist/classDetails";
            break;
          case 2:
            url="cateringRecord/classDetails";
            break;
        }
        if(stype!=0 && !this_.type){
          "未指定类型".showMessage();
          return;
        }
        let params = {};
        if(this_.etime) params.etime = this_.etime + " 00:00:00";
        if(this_.type) params.type = this_.type;

        schoolAxios({
          method: 'get',
          url: url,
          params: params
        }).then(function (resp) {
          if(resp.data.success){
            // console.info(this_.userId);
            this_.classList = resp.data.list;
            $("#classCountModal").modal("show");
          }else{
            (resp.data.message||"数据加载失败").showMessage();
          }
        });
      },
      classStudent(stype, type, id){
        let this_ = this;
        this_.stype = stype;
        this_.type = type;
        let url = "";
        switch (stype) {
          case 0:
            //无需执行
            return;
          case 1:
            //TODO
            // break;
                return;
          case 2:
            url="cateringRecord/details";
            break;
        }
        if(stype!=0 && !this_.type){
          "未指定类型".showMessage();
          return;
        }
        let params = {};
        if(this_.etime) params.etime = this_.etime + " 00:00:00";
        if(this_.type) params.type = this_.type;
        if(id) params.id = id;

        schoolAxios({
          method: 'get',
          url: url,
          params: params
        }).then(function (resp) {
          if(resp.data.success){
            // console.info(this_.userId);
            this_.studentList = resp.data.list;
            $("#classStudentModal").modal("show");
          }else{
            (resp.data.message||"数据加载失败").showMessage();
          }
        });
      },
      dateDefault(){
        let this_ = this;
        let date, nowDate;
        date = new Date();
        nowDate = date.getFullYear() + "-";
        nowDate += (date.getMonth() + 1) + "-";
        nowDate += date.getDate() + " ";
        this_.timeDate = nowDate;
        $('#menuDate').datetimepicker({
          minView: "month",//选择日期后，不会再跳转去选择时分秒
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,//选择一个日期后是否立即关闭此选择框
          todayHighlight: true,//高亮当前日期
          startView: 2,// 日期时间选择器打开之后首先显示的视图，默认值为：2，0:hour,1:day,2:mouth,3:year,4:decade
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let value = $("#menuDate").val();
          this_.data.menuDate = value;
          ev.preventDefault();
          ev.stopPropagation();
        }).on('changeDate', function (ev) {
          let value = $("#menuDate").val();
          this_.etime = value;
          this_.initData();
          ev.preventDefault();
          ev.stopPropagation();
        });
      },
      /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        //, #classStudentModal
        $("#classCountModal").on('hide.bs.modal', function () {
          this_.stype = 0;
          this_.type = 0;
        });
      }
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  .body_top {
    margin: 20px 0;
  }
  .table_trainingManage {
    border: 1px solid #ccc;
  }

  .searcharea{
    width: 80%;
    float: right;
    text-align: right;
  }
  .searcharea .form-control{
    display: inline-block;
    width: 160px;
  }
  .searcharea button{
    width: 60px;
  }

  .btn_square{
    width: 100px;
    height: 100px;
  }
  img.qrcode{
    background-image: url("../assets/img/right/clazz/qrcode.png");
  }
  img.refresh{
    background-image: url("../assets/img/right/clazz/refresh.png");
  }
  .btn_square img{
    margin: 10px auto;
    height: 48px;
    width: 48px;
    display: block;
  }
  .squareview{
    display: inline-block;
    height: 100px;
    margin: 0 20px;
    border: 2px solid #00CC00;
    position: relative;
  }
  .squareview .squaretext{
    display: inline-block;
    font-size: 30px;
    letter-spacing:5px;
    width: 100px;
    padding: 5px 12px;
  }
  .squareview .squarenumber{
    display: inline-block;
    font-size: 30px;
    letter-spacing:5px;
    width: 100px;
    padding: 5px 12px;
  }
  .squareview a{
    display: inline-block;
    position: absolute;
    top: 5px;
    right: 5px;
  }
  .historyview{
    width: 300px;
  }
  .historyview div{
    display: inline-block;
    width: 180px;
    text-align: right;
    line-height: 45px;
  }
  .title{
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 24px;
  }
  .meal{
    text-align: center;
  }
  .meal .squareview{
    margin: 10px auto;
    display: block;
    width: 220px;
  }
</style>



// WEBPACK FOOTER //
// src/components/cateringRecord.vue